<template>
	<div class="tabs">
		<el-tag
		  v-for="(tag,index) in tage"
		  :key="tag.path"
		  :closable="tag.name !== 'home'"
		  :effect = "$route.name === tag.name ? 'dark':'plain'"
		  @click="changeMenu(tag)"
		  @close = "handclose(tag,index)"
		  size="small"
		  >
		  {{tag.label}}
		</el-tag>
	</div>
</template>

<script>
	import {mapState} from "vuex"
	export default{
		name:'CommonTag',
		data(){
			return{}
		},
		computed:{
			...mapState({
				tage: state =>state.tab.tabsList
			})
		},
		methods:{
			//点击tag跳转
			changeMenu(item){
				this.$router.push(item.path)
			},
			handclose(item,index){
				const length = this.tage.length-1
				//删除
				this.$store.commit('closetag',item)
				//跳转
				if(item.name !== this.$route.name){
					return
				}
				//删除最后一项
				console.log(length,index);
				if (index === length) {
					this.$router.push({
						name:this.tage[index-1].name
					})
				} else{
					this.$router.push({
						name:this.tage[index].name
					})
				}
			}
		}
		
	}
</script>

<style lang="less" scopde>
	.tabs{
		padding: 20px;
		.el-tag{
			margin-right: 15px;
			cursor: pointer;
		}
	}
</style>